import * as React from "react";
import { IconType } from "react-icons/lib/esm/iconBase";
import styled from "styled-components";

interface IPageDirectionProps extends React.HTMLProps<HTMLButtonElement> {
  Icon: IconType;
}

export const PageControlButton = styled.button`
  background-color: unset;
  border: none;
  color: ${({ theme }) => theme.colors.buttonBlue};
  cursor: pointer;
  opacity: ${props => (props.disabled ? "0.4" : "1")};
`;

export const PageDirection: React.FC<IPageDirectionProps> = ({ Icon, disabled, onClick }) => (
  <PageControlButton data-testid="page-control-btn" disabled={disabled} onClick={onClick}>
    <Icon />
  </PageControlButton>
);
